import { IApplicationState } from '../../types/redux';

export const getReviewById = (id: string) => (state: IApplicationState) => {
  return state.reviews.byId[id];
};
